import _format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'

export function format(value) {
  return _format(parseISO(`2019-01-01T${value}`), 'h:mma').toLowerCase()
}
